import React from 'react';
import { motion } from 'framer-motion';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';

const faqs = [
  {
    q: 'Is this only for former athletes?',
    a: "It's built with former female athletes in mind, but it's for any woman 30+ ready to get strong, lean, and athletic again. If you're committed, the system will meet you where you are.",
  },
  {
    q: "I haven't trained in years. Can I still do this?",
    a: "Yes — you're not starting from scratch. Your plan is built around your current fitness level and progresses at the pace your body is ready for.",
  },
  {
    q: 'How is coaching delivered?',
    a: 'Everything runs through a structured online system: your workouts, nutrition guidance, check-ins, and progress tracking. The All-Star packages also include 2x/week live video coaching.',
  },
  {
    q: 'Do I need a gym?',
    a: 'No — your plan is built around the equipment you have, whether that\'s a full gym, a few dumbbells at home, or bodyweight to start.',
  },
  {
    q: "What's the difference between the packages?",
    a: 'All-Star includes 2x/week live video coaching plus training, nutrition, and accountability. Rookie includes a custom training plan, personalized nutrition, and tracking. Game Day Fuel is nutrition-focused with a personalized meal plan and bi-weekly accountability.',
  },
  {
    q: 'What if I have more questions before joining?',
    a: 'Tap "Apply Now" and fill out the form — Alou will get back to you. You can also reach out on Instagram @thedillonblueprint.',
  },
];

export const FitnessFAQ = () => {
  return (
    <section data-testid="fitness-faq" className="bg-black py-14 sm:py-16 lg:py-20 px-6">
      <div className="container mx-auto max-w-3xl">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.7 }}
          className="mb-10 text-center"
        >
          <p className="text-gray-400 font-bold text-xs tracking-[0.3em] uppercase mb-3">08 — Questions</p>
          <h2 className="font-display text-white text-4xl sm:text-5xl uppercase">FAQ</h2>
          <div className="w-16 h-1 bg-gray-400 mt-5 mx-auto" />
        </motion.div>

        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`fitness-faq-item-${i}`}
              className="border border-neutral-800 rounded-xl px-6 bg-neutral-950 data-[state=open]:border-gray-500"
            >
              <AccordionTrigger className="text-white font-bold text-left hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-gray-400 leading-relaxed">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
